import { render } from "./PayComplete.vue?vue&type=template&id=5c4f107e&scoped=true"
import script from "./PayComplete.vue?vue&type=script&lang=js"
export * from "./PayComplete.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=5c4f107e&scoped=true&lang=css"
import "@/assets/css/user/pages/keypad.css?vue&type=style&index=1&id=5c4f107e&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=5c4f107e&scoped=true&lang=css"
import "@/assets/css/user/dark/keypad-dark.css?vue&type=style&index=3&id=5c4f107e&scoped=true&lang=css"
import "./PayComplete.vue?vue&type=style&index=4&id=5c4f107e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4f107e"]])

export default __exports__